export default class UserProfile {
  constructor (data) {
    this.username = data.username;
    this.fullname = data.fullname;
    this.permission = data.permission;
    this.status = data.status;
    this.type = data.type;
    this.thumbnail = data.thumbnail;
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
  }
}
